module.exports = __webpack_public_path__ + "img/empty-avatar.54f8d092.png";